import { useQuery } from 'react-query';
import { createFetchAPI } from './http';

const fetchFlipper = createFetchAPI<
  FetchFlipperParams,
  FetchFlipperResponseType
>('v1/flippers');

export const useFetchFlipper = (props: FetchFlipperParams) =>
  useQuery<FetchFlipperResponseType>([props.key, { ...props }], fetchFlipper);

type FetchFlipperResponseType = {
  value: boolean;
};

type FetchFlipperParams = {
  key: FlipperKeys;
};

type FlipperKeys =
  | 'disable_fave_pass_onboarding'
  | 'disable_merchant_connect_favepay_transaction_fee_singapore'
  | 'disable_merchant_connect_favepay_transaction_fee_kuala-lumpur';
